//import { SignupReq } from './../../../.vscode-server/data/User/History/-17b62860/0fXZ';
import {
  DetectByArea,
  DetectByAreaParams,
  DetectByEventParams,
  DetectByMonth,
  DetectToday,
  GetMobilityLiveLevel,
  GetMobilityLiveList,
  GetPastClusteringList,
  GetPastClusteringParams,
  GetPastClusteringParams3,
  GetPastHistoryList,
  GetPastHistory,
  GetPastParams,
  CustomAxiosSingleType,
  PatchCancelParams,
  TripDistanceResult,
  GetDetectTodayParams,
  GetDetectLiveParams,
  GetDetectLiveLevelParams,
  GetDetectLiveClustering3Params,
  GetRoadAddressParams,
  GetTripDistanceParams,
  CustomListType,
  PostDetectDownloadParams,
  GetDetectEventDeviceParams,
  DetectEventDevice,
  DeleteMobility,
} from "./../types/types";
import {
  CustomAxiosType,
  DetectByDay,
  DetectByEvent,
  DetectByHour,
  DetectDetail,
  GetMobDetParams,
} from "../types/types";
import { client } from "./client";
import { convertLocaleToLang } from "../utils/langUtils";
import { Locale } from "../locales";

const b6t = `NB6T`;

// 현재 locale을 가져오는 헬퍼 함수 (localStorage에서)
const getCurrentLocale = (): Locale => {
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale && ["ko", "en", "zh", "ja", "vi", "es"].includes(savedLocale)) {
    return savedLocale as Locale;
  }
  return "ko"; // 기본값은 한국어
};

export interface AddressResult {
  distance_m: string;
  result: string;
}

// 일별 감지내역 리포트 조회
export const getDetectByDay = async ({
  endDate,
  startDate,
  area,
  groupId,
  mobility_code,
  lang,
}: DetectByEventParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<DetectByDay[]>>(
    `/api/report` + b6t + `/detect/day`,
    {
      endDate,
      startDate,
      area,
      groupId,
      mobility_code,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 감지내역통계 월별 조회
export const getDetectByMonth = async ({
  endDate,
  startDate,
  area,
  groupId,
  mobility_code,
  lang,
}: DetectByEventParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<DetectByMonth[]>>(
    `/api/report` + b6t + `/detect/month`,
    {
      endDate,
      startDate,
      area,
      groupId,
      mobility_code,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 종류별 감지내역 리포트 조회
export const getDetectByEvent = async ({
  endDate,
  startDate,
  ownerID,
  area,
  mobility_seq,
  groupId,
  mobility_code,
  lang,
}: DetectByEventParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<DetectByEvent[]>>(
    `/api/report` + b6t + `/detect/event`,
    {
      endDate,
      startDate,
      ownerID,
      area,
      mobility_seq,
      groupId,
      mobility_code,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 시간대별 감지내역 리포트 조회
export const getDetectByHour = async ({
  endDate,
  startDate,
  ownerID,
  area,
  groupId,
  mobility_code,
  mobility_seq,
  lang,
}: DetectByEventParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<DetectByHour[]>>(
    `/api/report` + b6t + `/detect/hour`,
    {
      endDate,
      startDate,
      ownerID,
      area,
      groupId,
      mobility_code,
      mobility_seq,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 감지 내역 상세 조회
export const getDetectDetail = async ({
  endDate,
  startDate,
  page,
  mobility_code,
  event_code,
  searchKey,
  area,
  sort,
  limit,
  groupId,
  lang,
}: GetMobDetParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<DetectDetail[]>>
  >(`/api/detection` + b6t + `/detail`, {
    endDate,
    startDate,
    page,
    mobility_code,
    event_code,
    searchKey,
    area,
    sort,
    limit,
    groupId,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

// 금일 감지 내역
export const getDetectToday = async ({
  event_code,
  area,
  lang,
}: GetDetectTodayParams & { lang?: string }) => {
  const response = await client.post<DetectToday>(`/api/detection` + b6t, {
    event_code,
    area,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });

  return response.data;
};

// 실시간 안전 관제 조회
export const getDetectLive = async ({
  mobility_code,
  searchKey,
  area,
  page,
  limit,
  swlng,
  swlat,
  nelng,
  nelat,
  startDate,
  endDate,
  event_code,
  groupId,
  runStat,
  lang,
}: GetDetectLiveParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<GetMobilityLiveList>>(
    `/api/detectionNB6T/monitoring`,
    {
      mobility_code,
      searchKey,
      area,
      page,
      limit,
      swlng,
      swlat,
      nelng,
      nelat,
      startDate,
      endDate,
      event_code,
      groupId,
      runStat,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 실시간 안전 관제 클러스터링 조회
export const getDetectLiveLevel = async ({
  // 현재 시도&시군구 클러스터링
  mobility_code,
  searchKey,
  area,
  level,
  lang,
}: GetDetectLiveLevelParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<GetMobilityLiveLevel[]>
  >(
    `/api/detectionNB6T/clustering
    `,
    {
      mobility_code,
      searchKey,
      area,
      level,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

export const getDetectLiveClustering2 = async ({
  // 현재 마커 전단계 클러스터링
  mobility_code,
  searchKey,
  area,
  level,
  lang,
}: GetDetectLiveLevelParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<GetMobilityLiveLevel[]>
  >(`/api/detectionNB6T/clustering2`, {
    mobility_code,
    searchKey,
    area,
    level,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};
export const getDetectLiveClustering3 = async ({
  // 현재 마커 전단계 클러스터링
  mobility_code,
  searchKey,
  area,
  eps,
  level,
  minPts,
  swlng,
  swlat,
  nelng,
  nelat,
  startDate,
  endDate,
  event_code,
  groupId,
  lang,
}: GetDetectLiveClustering3Params & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<GetMobilityLiveLevel[]>
  >(`/api/detectionNB6T/clustering3`, {
    mobility_code,
    searchKey,
    area,
    eps,
    level,
    minPts,
    swlng,
    swlat,
    nelng,
    nelat,
    startDate,
    endDate,
    event_code,
    groupId,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

// 과거 감지 내역
export const getDetectPast = async ({
  endDate,
  startDate,
  event_code,
  mobility_code,
  searchKey,
  area,
  page,
  limit,
  groupId,
  lang,
}: GetPastParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<GetPastHistoryList>>(
    `/api/detectionNB6T/history`,
    {
      endDate,
      startDate,
      event_code,
      mobility_code,
      searchKey,
      area,
      page,
      limit,
      groupId,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 감지내역 상세조회
export const getDetectPastDetail = async ({
  seq
}: DeleteMobility) => {
  const response = await client.post<CustomAxiosType<GetPastHistory>>(
    `/api/detectionNB6T/historyDetail`,
    {
      seq
    }
  );
  return response.data.result;
};

// 과거 감지 내역 클러스터링
export const getDetectPastClustering1 = async ({
  // 과거 시도&시군구 클러스터링
  endDate,
  startDate,
  event_code,
  mobility_code,
  searchKey,
  area,
  level,
  lang,
}: GetPastClusteringParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<GetPastClusteringList[]>
  >(`/api/detectionNB6T/historyClustering`, {
    endDate,
    startDate,
    event_code,
    mobility_code,
    searchKey,
    area,
    level,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

export const getDetectPastClustering2 = async ({
  // 과거 마커 전단계 클러스터링
  endDate,
  startDate,
  event_code,
  mobility_code,
  searchKey,
  area,
  level,
  lang,
}: GetPastClusteringParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<GetPastClusteringList[]>
  >(`/api/detectionNB6T/historyClustering2`, {
    endDate,
    startDate,
    event_code,
    mobility_code,
    searchKey,
    area,
    level,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

export const getDetectPastClustering3 = async ({
  // 과거  클러스터링 3
  endDate,
  startDate,
  event_code,
  mobility_code,
  searchKey,
  area,
  eps,
  minPts,
  level,
  groupId,
  lang,
}: GetPastClusteringParams3 & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<GetPastClusteringList[]>
  >(`/api/detectionNB6T/historyClustering3`, {
    endDate,
    startDate,
    event_code,
    mobility_code,
    searchKey,
    area,
    eps,
    minPts,
    level,
    groupId,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

// 감지 해지 사유 등록
export const putDetectCancel = async ({
  checker_name,
  header_seq,
  pid,
  reason,
}: PatchCancelParams) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/detection` + b6t + `/cancel-reason/patch`,
    {
      checker_name,
      header_seq,
      pid,
      reason,
    }
  );

  return response.data;
};

// 도로명 주소로 변환
export const getRoadAddress = async ({
  lng,
  lat,
}: GetRoadAddressParams) => {
  const response = await client.post<CustomAxiosType<AddressResult>>(
    `/api/detection` + b6t + `/road`,
    {
      longitude: String(lng),
      latitude: String(lat),
    }
  );
  // console.log(response.data.result.result);
  return response.data;
};

export const getDetectByArea = async ({
  area,
  lang,
}: DetectByAreaParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<DetectByArea[]>>(
    `/api/report` + b6t + `/detect/area`,
    {
      area,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 운행 거리 조회
export const getTripDistance = async ({
  mobility_seq,
  seq,
}: GetTripDistanceParams) => {
  const response = await client.post<CustomAxiosType<TripDistanceResult>>(
    `/api/detectionNB6T/tripDistance`,
    {
      mobility_seq,
      seq,
    }
  );
  return response.data.result;
};

// 실시간 감지내역 확인 체크 - 실시간 감지 내역에서 사용
export const putMonitoringCheck = async (event_seq: number) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/detection` + b6t + `/monitoring/patch`,
    {
      event_seq,
    }
  );
  return response.data;
};

// 농기계 운행 리포트 다운로드
export const postDetectDownload = async (
  params: PostDetectDownloadParams
) => {
  const response = await client.post<Blob>(
    `/api/report` + b6t + `/detect/download`,
    params,
    {
      responseType: "blob",
    }
  );

  return response;
};

// 감지 내역 상세 조회 다운로드
export const postDetectionDetailDownload = async (
  params: GetMobDetParams
) => {
  const response = await client.post<Blob>(
    `/api/detection` + b6t + `/detail/download`,
    params,
    {
      responseType: "blob",
    }
  );

  return response;
};

// 종류별 감지내역 리포트 이벤트별 기기 팝업 조회
export const getDetectEventDevice = async ({
  area,
  endDate,
  event_code,
  groupId,
  limit,
  mobility_code,
  mobility_seq,
  ownerID,
  page,
  startDate,
  lang,
}: GetDetectEventDeviceParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<DetectEventDevice[]>>
  >(`/api/report` + b6t + `/detect/event-device`, {
    area,
    endDate,
    event_code,
    groupId,
    limit,
    mobility_code,
    mobility_seq,
    ownerID,
    page,
    startDate,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};
